import { render, staticRenderFns } from "./Superbill.vue?vue&type=template&id=f5e1218a&scoped=true"
import script from "./Superbill.vue?vue&type=script&lang=js"
export * from "./Superbill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e1218a",
  null
  
)

export default component.exports